import { queryOptions, useMutation } from '@tanstack/react-query';
import { axiosDelete, axiosGet, axiosPost, axiosPut } from '../utils/api';

export const getAllProducts = ({ accessToken, params }) =>
  queryOptions({
    queryKey: ['/products', params],
    queryFn: async () => {
      const res = await axiosGet('/products', { params }, accessToken);
      return res.data;
    },
  });

export const useCreateProduct = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/products', data);
    },
  });

export const useUpdateProduct = () =>
  useMutation({
    mutationFn: ({ id, data }) => {
      return axiosPut(`/products/${id}`, data);
    },
  });

export const useDeleteProduct = () =>
  useMutation({
    mutationFn: ({ id, data }) => {
      return axiosDelete(`/products/${id}`, data);
    },
  });
